<template>
  <div class="container">
    <h1 class="sr-only" v-html="'Gift Card Redemption'"></h1>
      <div class="logo-container">
        <img src="../assets/sample-logo.png" alt=""/>
      </div>
      <div>
        <div id="error-msg-1" class="error-msg">
          <img src="../assets/exclamation-triangle.png" alt="" />
          <ErrorMessage />
        </div>
        <div id="error-msg-2" class="error-msg">
          <img src="../assets/exclamation-triangle.png" alt=""/>
          <p id="error-message-1" v-html="errorMessage ?  errorMessage : ''"></p>
        </div>
      </div>
      <img id="brandImage" class="brand-img" v-bind:src="image" :alt="!loading && `Gift card: ${rewardData.reward.name}`" />
      <h2 id="title"  v-if="!loading">{{rewardData.reward.name}}</h2>
      <div aria-hidden="true" class="separator"></div>
      <form v-if="tokenError === false"  id="withFormValidation">
        <label for="rcActivationCode" ref="challenge_code_label">{{challenge_code_label}}</label>
        <input aria-describedby="error-message" type="text" :maxlength="max" v-model="challengeCode" name="code" @keyup="format" id="rcActivationCode" @keyup.enter="redeem"/>
        <button ref="language"  @click.prevent="redeem" class="button submit" aria-readonly="true">{{'Continue'}}</button>
      </form>
    <span class="sr-only" role="status" aria-live="polite"  id="error-message" v-html="showLabel ?  getErrorMessage : ''"></span>
  </div>
</template>

<script>
  import axios from 'axios';
  import ErrorMessage from "./error-message";
  import { store } from '../../js/reactiveStates.js';

  export default {
    name: 'IndexPage',
    components: {ErrorMessage},
    // props: {
    //   msg: String
    // }
    computed: {
      getErrorMessage () {
        if (this.tokenError){
          return this.$t('errorMsg')
        } else {
          return this.errorMessage
        }
      },
    },
    data: function(){
      return {
        showLabel: false,
        rewardData:{},
        redemption_link:{},
        image:"",
        challengeCode:'',
        errorMessage : '',
        error : false,
        max:1000000,
        url: '/grs/v1/redemption_link/',
        loading: false,
        apiToken:'',
        root:process.env.VUE_APP_SERVICE_URL,
        tokenError: false,
        challenge_code_label:'Enter Your Challenge Code',
        store
      }
    },

    created() {
      this.loading = true;
      this.apiToken = this.$route.params.api_token;
     // this.url += this.apiToken;
      this.root += this.url;
      this.root += this.apiToken;

      this.details();
    },
    watch: {
      showLabel(val) {
        if (val) {
          setTimeout(() => {
            this.showLabel = false
          }, 3000)
        }
      },
      store: {
        handler(newStore){
          this.details(newStore.chosenLanguage);
        },
        deep: true
    }
    },
    methods:{
      details(lang = '') {

        axios.get(this.root+'?lang='+lang).then((resp) =>{
          this.rewardData = resp.data;
          if(this.rewardData.page_info.button_redeem && this.rewardData.page_info.button_redeem.length > 0){
            this.$refs.language.value = this.rewardData.page_info.button_redeem;
            if(store.manualLanguageSelect !== true && lang != store.chosenLanguage) {
              store.chosenLanguage = this.rewardData.page_info.language_code;
              this.$i18n.locale = store.chosenLanguage;
            }
          }


          if(this.rewardData.page_info.challenge_code_label && this.rewardData.page_info.challenge_code_label.length > 0){
            this.challenge_code_label = this.rewardData.page_info.challenge_code_label;
          }

          this.image = resp.data.reward.image;
          this.loading = false;

        }).catch((err) =>{
          let errorMsgEl = document.getElementById('error-msg-1');
          console.log(err);
          errorMsgEl.classList.add('active');
          this.tokenError = true;
          setTimeout(() => {
            this.showLabel = true
          }, 1000)
        })
      },

      redeem (){
        let body = {
          "challenge_code" : this.challengeCode
        };

        store.challengeCode = this.challengeCode

        let url = `${this.root}/redeem?lang=`+store.chosenLanguage;
        axios.post(url,body).then((resp)=>{
          if(resp.data.success === true){
            this.rewardData.message = resp.data.message;
            this.$emit('rewardData', this.rewardData);
            resp.data.redirect_to === 'process' ? this.$router.push({ path : "/page-2"}) : this.$router.push({ path : "/page-3"});

          } else {
            this.errorMessage = resp.data.message;
            this.showLabel = true
            let errorMsgEl = document.getElementById('error-msg-2');
            errorMsgEl.classList.add('active');

          }
        }).catch((error) => {
          console.log('Error', error)
        })

      },

      format(){
        let isSplit = false;
        let raw = this.challengeCode.trim().split('-').join('');
        let rawArr = raw.split('');
        if (raw.length > 20) {
          rawArr.splice(20, 0, '-');
          rawArr.splice(16, 0, '-');
          rawArr.splice(12, 0, '-');
          rawArr.splice(8, 0, '-');
          isSplit = true;

          // }else if (raw > 16){
          //   rawArr.splice(16,0, '\u2013');
          //   rawArr.splice(12, 0, '\u2013');
          //   rawArr.splice(8, 0, '\u2013');
          //   isSplit = true
          // }
          // else if (raw > 12) {
          //   rawArr.splice(12, 0, '\u2013');
          //   rawArr.splice(8, 0, '\u2013');
          //   isSplit = true;
          //
          // } else if (raw > 8) {
          //   rawArr.splice(8, 0, '\u2013');
          //   isSplit = true;
          // }
        }
        if (isSplit) {
          this.challengeCode = rawArr.join('')
        }
      }
    }
  }
</script>

<style scoped>
label {
  font-size: 24px;
  font-weight: bold;
}
form {
  margin-top: 0.5rem;
}
</style>
